// games-cloud hint bank API (SCRUM-686). See games-cloud/webserver/hints.go.
//
//   fetchHintBank(gameId)      -> { gameId, version, bank, updatedAt, updatedBy } | null (404/503)
//   listHintBanks()            -> [{ gameId, name, riddles, version, updatedAt, updatedBy }]
//   saveHintBank(gameId, version, bank) -> saved row; throws Error with .status (409 = stale)

import { GAMES_CLOUD_BASE } from "../utils/config";

function api(path, opts = {}) {
    const token = localStorage.getItem("accessToken");
    return fetch(`${GAMES_CLOUD_BASE}${path}`, {
        ...opts,
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}`, ...(opts.headers || {}) },
    });
}

export async function fetchHintBank(gameId) {
    if (!gameId) return null;
    const r = await api(`hints/${encodeURIComponent(gameId)}`);
    if (r.status === 404 || r.status === 503) return null;
    if (!r.ok) throw Object.assign(new Error(`hint bank: ${r.status}`), { status: r.status });
    return r.json();
}

export async function listHintBanks() {
    const r = await api("hints");
    if (r.status === 503) return [];
    if (!r.ok) throw Object.assign(new Error(`hint banks: ${r.status}`), { status: r.status });
    const data = await r.json();
    return data.banks || [];
}

export async function saveHintBank(gameId, version, bank) {
    const r = await api(`hints/${encodeURIComponent(gameId)}`, {
        method: "PUT",
        body: JSON.stringify({ version, bank }),
    });
    if (!r.ok) {
        const text = (await r.text()).trim();
        throw Object.assign(new Error(text || `save failed: ${r.status}`), { status: r.status });
    }
    return r.json();
}
